import type * as React from "react";
import { IconClickable, IconClickableType } from "~/common/components/icon/IconClickable";
import { IconType } from "~/common/components/icon/IconType";
import { IconSize } from "~/common/components/icon/IconSize";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import Modal from "~/common/components/Modal";
import classNames from "classnames";
import LanguageAwareExternalContent from "~/features/configurator/Linear/components/LanguageAwareExternalContent";

interface InfoBallProps {
  className?: string;
  onClick: (e: React.MouseEvent) => void;
}
export const InfoBall = ({ className, onClick }: InfoBallProps) => {
  return (
    <IconClickable
      clickableType={IconClickableType.SECONDARY}
      type={IconType.InformationCircle}
      size={IconSize.FONT_20}
      className={classNames("scha__info-ball", className)}
      onClick={onClick}
    />
  );
};

interface Props {
  className?: string;
  popupClassName?: string;
  info?: string;
}

/*
 * Warning: Please avoid using this component outside of Linear Configurator.
 * If you need it outside of LC, please extract an InfoBall component instead without extra url logic
 */
const LinearInfo = ({ info, className, popupClassName }: Props) => {
  const { val: modalOpen, setTrue, setFalse } = useBooleanState(false);

  if (!info) {
    return null;
  }

  const openModal = (e: React.MouseEvent) => {
    setTrue();
    e.stopPropagation();
    e.preventDefault();
  };

  const closeModal = (e: React.MouseEvent) => {
    setFalse();
    e.stopPropagation();
    e.preventDefault();
  };

  let extraClasses = "";
  if (isUrl(info)) {
    const params = new URLSearchParams(info.split("?")[1]);
    extraClasses = params.getAll("modalCls").join(" ");
  }

  return (
    <>
      <InfoBall className={classNames("scha__linear__configurator__info-ball", className)} onClick={openModal} />
      {modalOpen && (
        <Modal onClose={closeModal} modalClassName={classNames(popupClassName, extraClasses)}>
          <LanguageAwareExternalContent content={info} />
        </Modal>
      )}
    </>
  );
};
// TODO: Default imports are deprecated
export default LinearInfo;

const isUrl = (val: string) => val.startsWith("http");
